const skipCompress = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.has('skipCompress');
};

const skipPlayerLimits = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.has('skipPlayerLimits');
};

export const GameConfigDebugConfig = {
  skipCompress: skipCompress(),
  skipPlayerLimits: skipPlayerLimits(),
};
